/** Тип плагина. */
export enum PluginType {
    /** Отправка смс-оповещений клиенту. */
    Sms = "sms",

    /** Связь с клиентом. */
    ClientCommunication = "client-communication",
}
